import {
	Box,
	Button,
	Chip,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Divider,
	FormControlLabel,
	Link,
	Menu,
	MenuItem,
	Pagination,
	Paper,
	Radio,
	RadioGroup,
	Stack,
	Tab,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Tabs,
	TextField,
	Typography
} from '@mui/material'
import SearchInput from 'components/search/SearchInput'
import { BASE_API } from 'core/axios.config'
import { useApp } from 'core/contexts/profile.context'
import { dateFormatter } from 'core/helpers/date-formatter'
import { usePageParam } from 'core/hooks/usePageParam'
import { useSearchParamState } from 'core/hooks/useSearchParamState'
import { useTabParam } from 'core/hooks/useTabParam'
import { Document } from 'core/icons'
import moment from 'moment'
import { StatusColor, StatusText } from 'pages/HistoryPayment/enum'
import { parseLockers } from 'pages/Lockers/parse'
import React from 'react'
import { useMutation, useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
	cancelPaymentFiscalReceipt,
	closeSession,
	getBckOperations,
	getCashOperations,
	getKaspiOperations,
	getWalletOperations,
	runFiscalizationForDays,
	sendPaymentFiscalReceipt
} from 'services/payment/payment.service'
import { downloadFile } from 'services/report/report.service'

import { AnalyticsDialog } from './analytics-dialog'

export const HistoryPaymentPage = () => {
	const navigate = useNavigate()
	const { profile } = useApp()
	const [page, setPage] = usePageParam(1)
	const [search, setSearch, debouncedSearch] = useSearchParamState()
	const [openCloseModal, setOpenCloseModal] = React.useState(false)
	const [openFiscalizeDayModal, setOpenFiscalizeDayModal] = React.useState(false)
	const [fiscalizeMode, setFiscalizeMode] = React.useState<'day' | 'range' | 'list'>('day')
	const [fiscalizeDayDate, setFiscalizeDayDate] = React.useState(moment(new Date()).format('YYYY-MM-DD'))
	const [fiscalizeRangeFrom, setFiscalizeRangeFrom] = React.useState(moment(new Date()).format('YYYY-MM-DD'))
	const [fiscalizeRangeTo, setFiscalizeRangeTo] = React.useState(moment(new Date()).format('YYYY-MM-DD'))
	const [fiscalizeListDates, setFiscalizeListDates] = React.useState<string[]>([])
	const [fiscalizeListDraft, setFiscalizeListDraft] = React.useState(moment(new Date()).format('YYYY-MM-DD'))
	const [tab, setTab] = useTabParam('wallet')
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
	const open = Boolean(anchorEl)
	const [radioValue, setRadioValue] = React.useState('all')

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRadioValue((event.target as HTMLInputElement).value)
	}

	const [openProductsModal, setOpenProductsModal] = React.useState(false)
	const [openStaffModal, setOpenStaffModal] = React.useState(false)

	const handleProductsOpenModal = () => setOpenProductsModal(true)
	const handleProductsCloseModal = () => setOpenProductsModal(false)
	const handleStaffOpenModal = () => setOpenStaffModal(true)
	const handleStaffCloseModal = () => setOpenStaffModal(false)

	const [startDate, setStartDate] = React.useState(moment(new Date()).format('YYYY-MM-DD'))
	const [endDate, setEndDate] = React.useState(moment(new Date()).format('YYYY-MM-DD'))

	const onChangeStartDate = (e: any) => {
		setStartDate(e.target.value)
	}
	const onChangeEndDate = (e: any) => {
		setEndDate(e.target.value)
	}

	const { data: operations } = useQuery(['getWalletOperations', page, debouncedSearch], {
		queryFn: () =>
			getWalletOperations({
				page,
				search: debouncedSearch.length > 0 ? debouncedSearch : null
			})
	})
	const { data: bck } = useQuery(['getBckOperations', page, debouncedSearch], {
		queryFn: () =>
			getBckOperations({
				page,
				search: debouncedSearch.length > 0 ? debouncedSearch : null
			})
	})
	const { data: kaspi } = useQuery(['getKaspiOperations', page, debouncedSearch], {
		queryFn: () =>
			getKaspiOperations({
				page,
				search: debouncedSearch.length > 0 ? debouncedSearch : null
			})
	})
	const { data: cash } = useQuery(['getCashOperations', page, debouncedSearch], {
		queryFn: () =>
			getCashOperations({
				page,
				search: debouncedSearch.length > 0 ? debouncedSearch : null
			})
	})
	const closeSessionMutate = useMutation({
		mutationFn: (data: any) => closeSession(data),
		onSuccess: () => {
			toast.success('Сессии успешно закрыты!')
			setOpenCloseModal(false)
		}
	})

	const fiscalizeMutation = useMutation({
		mutationFn: (payload: any) => sendPaymentFiscalReceipt(payload),
		onSuccess: (res: any) => {
			toast.success(res?.message ?? 'Чек отправлен в Webkassa')
		}
	})

	const cancelFiscalMutation = useMutation({
		mutationFn: (payload: any) => cancelPaymentFiscalReceipt(payload),
		onSuccess: (res: any) => {
			toast.success(res?.message ?? 'Платёж отменён, возврат отправлен')
		}
	})

	const fiscalizeForDayMutation = useMutation({
		mutationFn: (payload: { dates?: string[]; from?: string; to?: string }) => runFiscalizationForDays(payload),
		onSuccess: (res: any) => {
			toast.success(res?.message ?? 'Фискализация запущена')
			setOpenFiscalizeDayModal(false)
		},
		onError: (err: any) => {
			toast.error(err?.response?.data?.message ?? 'Не удалось запустить фискализацию')
		}
	})

	const submitFiscalizeForDay = () => {
		if (fiscalizeMode === 'day') {
			fiscalizeForDayMutation.mutate({ dates: [fiscalizeDayDate] })
		} else if (fiscalizeMode === 'range') {
			fiscalizeForDayMutation.mutate({ from: fiscalizeRangeFrom, to: fiscalizeRangeTo })
		} else {
			fiscalizeForDayMutation.mutate({ dates: fiscalizeListDates })
		}
	}

	const addFiscalizeListDate = () => {
		if (!fiscalizeListDraft) return
		if (fiscalizeListDates.includes(fiscalizeListDraft)) return
		setFiscalizeListDates([...fiscalizeListDates, fiscalizeListDraft].sort())
	}

	const removeFiscalizeListDate = (d: string) => {
		setFiscalizeListDates(fiscalizeListDates.filter(x => x !== d))
	}

	const isFiscalizeSubmitDisabled =
		fiscalizeForDayMutation.isLoading ||
		(fiscalizeMode === 'day' && !fiscalizeDayDate) ||
		(fiscalizeMode === 'range' &&
			(!fiscalizeRangeFrom || !fiscalizeRangeTo || fiscalizeRangeTo < fiscalizeRangeFrom)) ||
		(fiscalizeMode === 'list' && fiscalizeListDates.length === 0)

	const onFiscalize = (paymentMethod: string, paymentId: number) => () => {
		fiscalizeMutation.mutate({ payment_method: paymentMethod, payment_id: paymentId })
	}
	const onCancelFiscal = (paymentMethod: string, paymentId: number) => () => {
		// eslint-disable-next-line no-alert
		if (!window.confirm('Отменить платёж и отправить чек возврата? Деньги будут возвращены клиенту.')) {
			return
		}
		cancelFiscalMutation.mutate({ payment_method: paymentMethod, payment_id: paymentId })
	}

	const handleSessionOpenModal = () => setOpenCloseModal(true)
	const handleSessionCloseModal = () => setOpenCloseModal(false)
	const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
		setTab(newValue)
	}
	const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
		setPage(value)
	}
	const onClickCloseSession = () => {
		closeSessionMutate.mutate({})
	}
	const onChangeSearch = (e: any) => {
		setSearch(e.target.value)
	}

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		handleProductsCloseModal()
		handleStaffCloseModal()
		setAnchorEl(null)
		setStartDate(moment(new Date()).format('YYYY-MM-DD'))
		setEndDate(moment(new Date()).format('YYYY-MM-DD'))
	}

	const handleSubmitReportProducts = () => {
		let dates = ''
		if (radioValue === 'range') {
			dates = `?start_date=${startDate}&end_date=${endDate}`
		}
		const url = `${BASE_API}/back_office/reports/order${dates}`
		downloadFile(url, 'productsReport')
		handleClose()
	}

	const handleSubmitReportStaff = () => {
		let dates = ''
		if (radioValue === 'range') {
			dates = `?start_date=${startDate}&end_date=${endDate}`
		}
		const url = `${BASE_API}/back_office/reports/employee${dates}`
		downloadFile(url, 'employeesReport')
		handleClose()
	}

	return (
		<div>
			<Box display='flex' justifyContent='space-between' p={2}>
				<Typography variant='title_2'>История платежей</Typography>
				<Box display='flex' justifyContent='space-between'>
					<Button
						color='info'
						variant='text'
						size='small'
						aria-controls={open ? 'basic-menu' : undefined}
						aria-haspopup='true'
						aria-expanded={open ? 'true' : undefined}
						onClick={handleClick}
						sx={{ border: 0, borderRadius: '50%', marginRight: 5 }}
					>
						<Document style={{ marginRight: '12px' }} />
						Скачать отчет
					</Button>
					<Menu
						id='basic-menu'
						anchorEl={anchorEl}
						open={open}
						onClose={handleClose}
						MenuListProps={{
							'aria-labelledby': 'basic-button'
						}}
					>
						<MenuItem onClick={handleProductsOpenModal} key='menu-item-1'>
							По продажам продуктов
						</MenuItem>
						<MenuItem onClick={handleStaffOpenModal} key='menu-item-2'>
							По продажам официантов
						</MenuItem>
					</Menu>

					<Button
						onClick={() => setOpenFiscalizeDayModal(true)}
						variant='outlined'
						color='info'
						sx={{
							marginRight: '8px'
						}}
					>
						Фискализировать за день
					</Button>
					<Button
						onClick={handleSessionOpenModal}
						variant='outlined'
						color='error'
						sx={{
							marginRight: '8px'
						}}
					>
						Закрыть сессии касс
					</Button>
					{profile?.user?.role.permissions.includes('wallet_deposit') && (
						<Button onClick={() => navigate(`/payment-history/payment-page`)} variant='contained'>
							Внести платеж
						</Button>
					)}
				</Box>
			</Box>
			<Divider />
			<Box p={2} display='flex' justifyContent='center' alignItems='center' gap={2}>
				<Tabs value={tab} onChange={handleChangeTab} aria-label='wrapped label tabs example'>
					<Tab value='wallet' label='Кошельки' wrapped />
					<Tab value='bck' label='БЦК транзакции' />
					<Tab value='kaspi' label='Kaspi' />
					<Tab value='cash' label='Наличные' />
				</Tabs>
			</Box>
			<Divider />
			<Box display='flex' justifyContent='end' p={1}>
				<SearchInput search={search} onChangeSearch={onChangeSearch} />
			</Box>
			<Divider />
			<TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
				<Table size='small' sx={{ minWidth: 650, '& th, & td': { px: 1, py: 0.75 } }} aria-label='simple table'>
					<TableHead>
						<TableRow>
							<TableCell>ID</TableCell>
							<TableCell align='left'>Дата</TableCell>
							<TableCell align='left'>Операция</TableCell>
							<TableCell align='left'>Тип</TableCell>
							<TableCell align='left'>Сумма</TableCell>
							<TableCell align='left'>Остаток</TableCell>
							<TableCell align='left'>Владелец</TableCell>
							<TableCell align='left'>Метод</TableCell>
							<TableCell align='left'>Заказ</TableCell>
							<TableCell align='left'>Статус</TableCell>
							<TableCell align='left'>Чек</TableCell>
							<TableCell align='center'>Действия</TableCell>
						</TableRow>
					</TableHead>
					{tab === 'wallet' && (
						<TableBody>
							{operations?.data &&
								parseLockers(operations.data).map((row: any) => (
									<TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
										<TableCell component='th' scope='row'>
											{row.id}
										</TableCell>
										<TableCell align='left'>{dateFormatter(new Date(row.created_at))}</TableCell>
										<TableCell
											align='left'
											sx={{
												color: row.type === 'Пополнение' ? '#24D321' : '#f59b52'
											}}
										>
											<strong>{row.type}</strong>
										</TableCell>
										<TableCell align='left'>{row.purchase_type}</TableCell>
										<TableCell align='left'>
											<strong>{row.amount}</strong>
										</TableCell>
										<TableCell align='left'>
											<strong>{row.amount_after}</strong>
										</TableCell>
										<TableCell align='left'>
											<Link href={`/payment-history/${row.id}`} underline='none' color='inherit'>
												<strong>{row.customer_full_name}</strong>
											</Link>
										</TableCell>
										<TableCell align='left'>{row.provider}</TableCell>
										<TableCell align='left'>{row.order_id}</TableCell>
										<TableCell
											align='center'
											sx={{
												color: StatusColor[row.status as keyof typeof StatusColor]
											}}
										>
											<strong>{StatusText[row.status as keyof typeof StatusText]}</strong>
										</TableCell>
										<TableCell
											align='center'
											sx={{
												color: row.receipt_sent === true ? '#24D321' : '#f55252'
											}}
										>
											<strong>{row.receipt_sent === true ? 'Да' : 'Нет'}</strong>
										</TableCell>
										<TableCell align='center'>
											<Box display='flex' flexDirection='column' gap={0.5}>
												<Button
													size='small'
													variant='text'
													disabled={fiscalizeMutation.isLoading || row.receipt_sent === true}
													onClick={onFiscalize('wallet', row.id)}
												>
													<span style={{ fontSize: '12px' }}>Фискализировать</span>
												</Button>
												<Button
													size='small'
													variant='text'
													color='error'
													disabled={
														cancelFiscalMutation.isLoading || row.receipt_sent !== true
													}
													onClick={onCancelFiscal('wallet', row.id)}
												>
													<span style={{ fontSize: '12px' }}>Отменить</span>
												</Button>
											</Box>
										</TableCell>
									</TableRow>
								))}
						</TableBody>
					)}
					{tab === 'bck' && (
						<TableBody>
							{bck?.data &&
								parseLockers(bck.data).map((bckRow: any) => (
									<TableRow
										key={bckRow.id}
										sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
									>
										<TableCell component='th' scope='row'>
											{bckRow.id}
										</TableCell>
										<TableCell align='left'>{dateFormatter(new Date(bckRow.created_at))}</TableCell>
										<TableCell
											align='left'
											sx={{
												color: bckRow.type === 'Списание' ? '#f59b52' : '#24D321'
											}}
										>
											<strong>{bckRow.type}</strong>
										</TableCell>
										<TableCell align='left'>{bckRow.purchase_type}</TableCell>
										<TableCell align='left'>
											<strong>{bckRow.amount}</strong>
										</TableCell>
										<TableCell align='left'>
											<strong>{bckRow.amount_after === null ? '-' : bckRow.amount_after}</strong>
										</TableCell>
										<TableCell align='left'>
											<Link
												href={`/payment-history/${bckRow.id}`}
												underline='none'
												color='inherit'
											>
												<strong>{bckRow.customer_full_name}</strong>
											</Link>
										</TableCell>
										<TableCell align='left'>BCC</TableCell>
										<TableCell align='left'>{bckRow.order_id}</TableCell>
										<TableCell
											align='left'
											sx={{
												color: StatusColor[bckRow.status as keyof typeof StatusColor]
											}}
										>
											<strong>{StatusText[bckRow.status as keyof typeof StatusText]}</strong>
										</TableCell>
										<TableCell
											align='center'
											sx={{
												color: bckRow.receipt_sent === true ? '#24D321' : '#f55252'
											}}
										>
											<strong>{bckRow.receipt_sent === true ? 'Да' : 'Нет'}</strong>
										</TableCell>
										<TableCell align='center'>
											<Box display='flex' flexDirection='column' gap={0.5}>
												<Button
													size='small'
													variant='text'
													disabled={
														fiscalizeMutation.isLoading || bckRow.receipt_sent === true
													}
													onClick={onFiscalize('processing', bckRow.id)}
												>
													<span style={{ fontSize: '12px' }}>Фискализировать</span>
												</Button>
												<Button
													size='small'
													variant='text'
													color='error'
													disabled={
														cancelFiscalMutation.isLoading || bckRow.receipt_sent !== true
													}
													onClick={onCancelFiscal('processing', bckRow.id)}
												>
													<span style={{ fontSize: '12px' }}>Отменить</span>
												</Button>
											</Box>
										</TableCell>
									</TableRow>
								))}
						</TableBody>
					)}
					{tab === 'kaspi' && (
						<TableBody>
							{kaspi?.data &&
								parseLockers(kaspi.data).map((kaspiRow: any) => (
									<TableRow
										key={kaspiRow.id}
										sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
									>
										<TableCell component='th' scope='row'>
											{kaspiRow.id}
										</TableCell>
										<TableCell align='left'>
											{dateFormatter(new Date(kaspiRow.created_at))}
										</TableCell>
										<TableCell
											align='left'
											sx={{ color: kaspiRow.type === 'Списание' ? '#f59b52' : '#24D321' }}
										>
											<strong>{kaspiRow.type}</strong>
										</TableCell>
										<TableCell align='left'>{kaspiRow.purchase_type}</TableCell>
										<TableCell align='left'>
											<strong>{kaspiRow.amount}</strong>
										</TableCell>
										<TableCell align='left'>
											<strong>
												{kaspiRow.amount_after === null ? '-' : kaspiRow.amount_after}
											</strong>
										</TableCell>
										<TableCell align='left'>
											<Link
												href={`/payment-history/${kaspiRow.id}`}
												underline='none'
												color='inherit'
											>
												<strong>{kaspiRow.customer_full_name}</strong>
											</Link>
										</TableCell>
										<TableCell align='left'>{kaspiRow.provider ?? 'Kaspi'}</TableCell>
										<TableCell align='left'>{kaspiRow.order_id}</TableCell>
										<TableCell
											align='left'
											sx={{ color: StatusColor[kaspiRow.status as keyof typeof StatusColor] }}
										>
											<strong>{StatusText[kaspiRow.status as keyof typeof StatusText]}</strong>
										</TableCell>
										<TableCell
											align='center'
											sx={{ color: kaspiRow.receipt_sent === true ? '#24D321' : '#f55252' }}
										>
											<strong>{kaspiRow.receipt_sent === true ? 'Да' : 'Нет'}</strong>
										</TableCell>
										<TableCell align='center'>
											<Box display='flex' flexDirection='column' gap={0.5}>
												<Button
													size='small'
													variant='text'
													disabled={
														fiscalizeMutation.isLoading || kaspiRow.receipt_sent === true
													}
													onClick={onFiscalize(
														kaspiRow.payment_method ?? 'kaspi',
														kaspiRow.id
													)}
												>
													<span style={{ fontSize: '12px' }}>Фискализировать</span>
												</Button>
												<Button
													size='small'
													variant='text'
													color='error'
													disabled={
														cancelFiscalMutation.isLoading || kaspiRow.receipt_sent !== true
													}
													onClick={onCancelFiscal(
														kaspiRow.payment_method ?? 'kaspi',
														kaspiRow.id
													)}
												>
													<span style={{ fontSize: '12px' }}>Отменить</span>
												</Button>
											</Box>
										</TableCell>
									</TableRow>
								))}
						</TableBody>
					)}
					{tab === 'cash' && (
						<TableBody>
							{cash?.data &&
								parseLockers(cash.data).map((cashRow: any) => (
									<TableRow
										key={cashRow.id}
										sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
									>
										<TableCell component='th' scope='row'>
											{cashRow.id}
										</TableCell>
										<TableCell align='left'>
											{dateFormatter(new Date(cashRow.created_at))}
										</TableCell>
										<TableCell
											align='left'
											sx={{ color: cashRow.type === 'Списание' ? '#f59b52' : '#24D321' }}
										>
											<strong>{cashRow.type}</strong>
										</TableCell>
										<TableCell align='left'>{cashRow.purchase_type}</TableCell>
										<TableCell align='left'>
											<strong>{cashRow.amount}</strong>
										</TableCell>
										<TableCell align='left'>
											<strong>
												{cashRow.amount_after === null ? '-' : cashRow.amount_after}
											</strong>
										</TableCell>
										<TableCell align='left'>
											<Link
												href={`/payment-history/${cashRow.id}`}
												underline='none'
												color='inherit'
											>
												<strong>{cashRow.customer_full_name}</strong>
											</Link>
										</TableCell>
										<TableCell align='left'>{cashRow.provider ?? 'Наличные'}</TableCell>
										<TableCell align='left'>{cashRow.order_id}</TableCell>
										<TableCell
											align='left'
											sx={{ color: StatusColor[cashRow.status as keyof typeof StatusColor] }}
										>
											<strong>{StatusText[cashRow.status as keyof typeof StatusText]}</strong>
										</TableCell>
										<TableCell
											align='center'
											sx={{ color: cashRow.receipt_sent === true ? '#24D321' : '#f55252' }}
										>
											<strong>{cashRow.receipt_sent === true ? 'Да' : 'Нет'}</strong>
										</TableCell>
										<TableCell align='center'>
											<Box display='flex' flexDirection='column' gap={0.5}>
												<Button
													size='small'
													variant='text'
													disabled={
														fiscalizeMutation.isLoading || cashRow.receipt_sent === true
													}
													onClick={onFiscalize('external_accepted', cashRow.id)}
												>
													<span style={{ fontSize: '12px' }}>Фискализировать</span>
												</Button>
												<Button
													size='small'
													variant='text'
													color='error'
													disabled={
														cancelFiscalMutation.isLoading || cashRow.receipt_sent !== true
													}
													onClick={onCancelFiscal('external_accepted', cashRow.id)}
												>
													<span style={{ fontSize: '12px' }}>Отменить</span>
												</Button>
											</Box>
										</TableCell>
									</TableRow>
								))}
						</TableBody>
					)}
				</Table>
			</TableContainer>
			{(() => {
				const sourcesByTab: Record<string, any> = { wallet: operations, bck, kaspi, cash }
				const activeSource = sourcesByTab[tab]
				return activeSource?.last_page ? (
					<Box display='flex' justifyContent='center'>
						<Pagination
							sx={{ marginTop: '16px' }}
							count={activeSource.last_page}
							page={page}
							onChange={handleChangePage}
						/>
					</Box>
				) : null
			})()}
			<Dialog
				open={openCloseModal}
				onClose={handleSessionCloseModal}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
			>
				<DialogTitle id='alert-dialog-title'>Вы уверены?</DialogTitle>
				<DialogContent>
					<DialogContentText id='alert-dialog-description'>
						Подтвердите ваше действие о закрытии сессии касс
					</DialogContentText>
				</DialogContent>
				<DialogActions
					sx={{
						display: 'flex',
						justifyContent: 'space-between'
					}}
				>
					<Button onClick={handleSessionCloseModal} variant='outlined'>
						<span
							style={{
								color: 'red',
								paddingLeft: '40px',
								paddingRight: '40px'
							}}
						>
							Отменить
						</span>
					</Button>
					<Button onClick={onClickCloseSession} variant='contained' color='info'>
						<span
							style={{
								color: 'white',
								paddingLeft: '55px',
								paddingRight: '55px'
							}}
						>
							Да
						</span>
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog
				open={openFiscalizeDayModal}
				onClose={() => setOpenFiscalizeDayModal(false)}
				aria-labelledby='fiscalize-day-title'
				fullWidth
				maxWidth='sm'
			>
				<DialogTitle id='fiscalize-day-title'>Фискализация за период</DialogTitle>
				<DialogContent>
					<DialogContentText sx={{ mb: 2 }}>
						Запустит фискализацию всех платежей со статусом NOT_SENT / FAILED за выбранные дни. Уже
						отправленные чеки повторно не пойдут — фильтр по статусу + идемпотентность Webkassa. Максимум 90
						дней за один запрос.
					</DialogContentText>
					<RadioGroup
						row
						value={fiscalizeMode}
						onChange={e => setFiscalizeMode(e.target.value as 'day' | 'range' | 'list')}
						sx={{ mb: 2 }}
					>
						<FormControlLabel value='day' control={<Radio />} label='Один день' />
						<FormControlLabel value='range' control={<Radio />} label='Диапазон' />
						<FormControlLabel value='list' control={<Radio />} label='Список дат' />
					</RadioGroup>

					{fiscalizeMode === 'day' && (
						<TextField
							type='date'
							label='Дата'
							value={fiscalizeDayDate}
							onChange={e => setFiscalizeDayDate(e.target.value)}
							InputLabelProps={{ shrink: true }}
							fullWidth
						/>
					)}

					{fiscalizeMode === 'range' && (
						<Stack direction='row' spacing={2}>
							<TextField
								type='date'
								label='От'
								value={fiscalizeRangeFrom}
								onChange={e => setFiscalizeRangeFrom(e.target.value)}
								InputLabelProps={{ shrink: true }}
								fullWidth
							/>
							<TextField
								type='date'
								label='До (включительно)'
								value={fiscalizeRangeTo}
								onChange={e => setFiscalizeRangeTo(e.target.value)}
								InputLabelProps={{ shrink: true }}
								fullWidth
								error={!!fiscalizeRangeTo && fiscalizeRangeTo < fiscalizeRangeFrom}
								helperText={
									fiscalizeRangeTo && fiscalizeRangeTo < fiscalizeRangeFrom
										? 'До должно быть не раньше От'
										: ''
								}
							/>
						</Stack>
					)}

					{fiscalizeMode === 'list' && (
						<Box>
							<Stack direction='row' spacing={1} sx={{ mb: 2 }}>
								<TextField
									type='date'
									label='Добавить дату'
									value={fiscalizeListDraft}
									onChange={e => setFiscalizeListDraft(e.target.value)}
									InputLabelProps={{ shrink: true }}
									fullWidth
								/>
								<Button
									onClick={addFiscalizeListDate}
									variant='outlined'
									disabled={!fiscalizeListDraft || fiscalizeListDates.includes(fiscalizeListDraft)}
								>
									Добавить
								</Button>
							</Stack>
							<Box display='flex' flexWrap='wrap' gap={1}>
								{fiscalizeListDates.length === 0 && (
									<Typography variant='body2' color='text.secondary'>
										Пока нет дат
									</Typography>
								)}
								{fiscalizeListDates.map(d => (
									<Chip key={d} label={d} onDelete={() => removeFiscalizeListDate(d)} />
								))}
							</Box>
						</Box>
					)}
				</DialogContent>
				<DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
					<Button onClick={() => setOpenFiscalizeDayModal(false)} variant='outlined'>
						Отменить
					</Button>
					<Button
						onClick={submitFiscalizeForDay}
						variant='contained'
						color='info'
						disabled={isFiscalizeSubmitDisabled}
					>
						Запустить
					</Button>
				</DialogActions>
			</Dialog>
			<AnalyticsDialog
				openModal={openProductsModal}
				handleCloseModal={handleProductsCloseModal}
				value={radioValue}
				handleChange={handleChange}
				title='Скачивание отчета по продажам продуктов'
				startDate={startDate}
				onChangeStartDate={onChangeStartDate}
				endDate={endDate}
				onChangeEndDate={onChangeEndDate}
				handleSubmit={handleSubmitReportProducts}
			/>
			<AnalyticsDialog
				openModal={openStaffModal}
				handleCloseModal={handleStaffCloseModal}
				value={radioValue}
				handleChange={handleChange}
				title='Скачивание отчета по продажам официантов'
				startDate={startDate}
				onChangeStartDate={onChangeStartDate}
				endDate={endDate}
				onChangeEndDate={onChangeEndDate}
				handleSubmit={handleSubmitReportStaff}
			/>
		</div>
	)
}
